export const ROW_OPTIONS = [5, 10, 25, 50, 100] as const;
export const VISIBLE_PAGE_COUNT = 3;
